/* eslint-disable */
// @ts-nocheck

import React, { useState } from "react";
import Button, { Icons } from "../buttons/Button";
import DeleteModal from "../modal/DeleteModal";
import { SIDEPANEL_GENERAL_TRANSLATIONS } from "../../translations/util";

interface IProps {
  toggleFilterPanel: React.Dispatch<React.SetStateAction<boolean>>;
  className: string;
  panelName: string;
  panelContent: React.ReactNode;
  showDelete: boolean;
  onDelete?: () => void;
  deleteModalDesc?: string;
}

const SidePanel = ({
  toggleFilterPanel,
  className,
  panelName,
  panelContent,
  showDelete,
  onDelete,
  deleteModalDesc,
}: IProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <aside id="sidepanel" className={className} data-cy="sidepanel">
        <div className="panel-header">
          <div className="panel-left-side">
            <Button
              kind="ghost"
              className="close-btn"
              icon={Icons.Close}
              onClick={toggleFilterPanel}
              dataCy="closeSidepanel-"
            />
            <h5 data-cy="panelName"> {panelName} </h5>
          </div>

          {showDelete ? (
            <div className="panel-right-side">
              <Button
                kind="tertiary"
                className="w-full"
                label={SIDEPANEL_GENERAL_TRANSLATIONS.buttonLabels.delete}
                icon={Icons.Delete}
                onClick={() => {
                  return setOpen(true);
                }}
              />
            </div>
          ) : (
            <div />
          )}
        </div>

        {panelContent}
      </aside>
      {onDelete ? (
        <DeleteModal
          modalHeaderText={SIDEPANEL_GENERAL_TRANSLATIONS.deleteModal.header}
          modalDescriptionText={deleteModalDesc}
          onDelete={onDelete}
          open={open}
          setOpen={setOpen}
        />
      ) : null}
    </>
  );
};
export default SidePanel;
